import Features from '../../content/Features';
import {hasLatestWebAudioSupport, audioWarning} from '../../components/SoundFx';

export default function initFeatures() {
  if (hasLatestWebAudioSupport) {
    Features.Accessible();
    Features.Extensible();
    Features.Interaction();
    Features.Animation();
  } else {
    console.warn(audioWarning);
  }
}
